/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.IdlePolicy
*/
export var IdlePolicy;
(function (IdlePolicy) {
    IdlePolicy["SUSPEND"] = "SUSPEND";
    IdlePolicy["NONE"] = "NONE";
})(IdlePolicy || (IdlePolicy = {}));
//# sourceMappingURL=IdlePolicy.js.map